(function () {
  'use strict';

  angular.module('app').component('banksPage', BanksPageComponent());

  function BanksPageComponent() {
    return {
      bindings: {},
      controller: BanksCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/banks/banks-page.component.html',
    };
  }

  BanksCtrl.$inject = ['UtilService', 'AbilityService', 'BankService', 'LanguageService', 'SessionService'];

  function BanksCtrl(UtilService, AbilityService, BankService, LanguageService, SessionService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canCreate: AbilityService.can('create_bank_accountadmin'),
    };

    // Methods
    vm.createItem = createItem;
    vm.onShowItem = onShowItem;

    // Initializers
    // getItems();
    getAdditionalLanguages();

    function getItems(selectedItem) {
      vm.filterCriteria = BankService.getFilterCriteria();
      vm.filterCriteria.lang = SessionService.getUserLanguage().code;

      vm.loadingItems = true;
      BankService.getBanks(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        if (selectedItem) {
          vm.UtilService.itemListChanged(selectedItem.id);
        }
      });
    }

    function getAdditionalLanguages() {
      LanguageService.getLanguages({ skip_check_role: true }).then(function (data) {
        let languages = data.items;

        // Use the system's default language (usually English) for data storage
        let defaultLanguage = languages.filter((language) => language.is_default)[0];
        
        // Use user's current language as the primary language for create/edit
        vm.userLanguageCode = SessionService.getUserLanguage().code;
        
        // Additional languages should be all languages EXCEPT the user's current language
        vm.additionalLanguages = languages.filter((language) => language.lang !== vm.userLanguageCode);

        getItems('');
      });
    }

    function createItem() {
      BankService.openBankModal({}, vm.userLanguageCode, vm.additionalLanguages, 'create', getItems);
    }

    function onShowItem(item, mode) {
      BankService.openBankModal(item, vm.userLanguageCode, vm.additionalLanguages, mode);
    }
  }
})();
